<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<!-- <div class="h-10 visible-xs" *ngIf="!enableLoader">
</div> -->
<!-- <div class="p-2">
    <span class="mobile-header hidden-xs ml-4"></span>
</div> -->
<div *ngIf="enableLoader" id="loader" class='align-items-center'></div>
<div class="container text-center strong  text-secondary py-4" *ngIf="noData">{{'home.contracts.Noresults' | cxTranslate }}</div>
<!-- <div class="h-10 visible-xs" *ngIf="enableLoader">

</div> -->

<div class="container d-flex flex-column justify-content-center py-4">
    <table *ngIf="groupcompanies && !enableLoader">
        <thead role="rowgroup" *ngIf="!noData">
            <tr role="row" class="bg-table-header border-bottom" *ngIf="!noData">
                <th class=' p-7'>{{'heading.GroupCompanies' | cxTranslate}}</th>
                <th class=' p-7'>{{'heading.RegisteredAddress' | cxTranslate}}</th>
                <th class=' p-7'>{{'heading.Website' | cxTranslate}}</th>
                <!-- <th class=' p-7'>{{'heading.Social1' | cxTranslate}}</th> -->
            </tr>
        </thead>
        <tbody role="rowgroup">
            <tr role="row" (click)="navigateToDetails()" class="bg-white border-bottom pe-auto" *ngFor="let i of groupcompanies">
                <td [attr.data-label]="'heading.GroupCompanies' | cxTranslate" role="cell" class=' p-7 pe-auto'>{{i.name | titlecase}}</td>
                <td [attr.data-label]="'heading.RegisteredAddress' | cxTranslate" role="cell" class=' p-7'>{{i.addresses[0].formattedAddress ? i.addresses[0].formattedAddress : 'NA'}}</td>
                <td [attr.data-label]="'heading.Website' | cxTranslate" role="cell" class=' p-7'><a *ngIf="i.website" href="{{i.website}}" target="_blank">{{i.website}}</a><a *ngIf="!i.website">NA</a></td>
                <!-- <td [attr.data-label]="'heading.Social1' | cxTranslate" role="cell" class=' p-7'><a *ngIf="i.socialMediaUrl" href="{{i.socialMediaUrl}}" target="_blank">{{i.socialMediaUrl}}</a> <a *ngIf="!i.socialMediaUrl">NA</a></td> -->
            </tr>
        </tbody>
    </table>
</div>